import { Props } from './types';

const Summary = ({ tour }: Props) => (
  <div className="summary-block">
    {/* eslint-disable-next-line react/no-danger */}
    {tour?.summary && <p className="m-0 mw-100 p-3" dangerouslySetInnerHTML={{ __html: tour?.summary }} />}
    <div className="clearfix" />
    <div className="line" />
    {tour.amenities && <h2>{tour.client.rtl ? 'מאפיינים' : 'AMENITIES'}</h2>}
  </div>
);

export default Summary;
